import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { GallerySortNames } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { idFromObject } from '@sorare/core/src/gql/idFromObject';

import { DropWarning } from '@sorare/marketplace/src/components/commonCard/DropWarning';
import { useUserCardsSearchClient } from '@sorare/marketplace/src/hooks/search/useUserCardsSearchClient';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { commonCardsFilters } from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import { BaseballCardSearch } from 'components/searchCards/BaseballCardSearch';

const sorts: GallerySortNames = [
  'Cards New',
  'Cards Highest Average Score',
  'Cards Player Name',
];

const cardFilters = commonCardsFilters(true);

const Search = ({ id, slug }: { slug: string; id: string }) => {
  const droppingDefaultFilters = useDefaultFilters({
    userId: idFromObject(id),
    rarity: Rarity.common,
  });

  const searchClient = useUserCardsSearchClient(slug, {
    rarity: Rarity.common,
    sport: Sport.BASEBALL,
  });

  return (
    <BaseballCardSearch
      sorts={sorts}
      analyticsTags={['Baseball', 'Swap']}
      cardFilters={cardFilters}
      defaultFilters={droppingDefaultFilters}
      commonMarket
      hideOwner
      defaultHitsPerPage={40}
      hideSavedFilters
      alwaysShowFavoriteButton={false}
      searchClient={searchClient}
      selectionMode="drop"
    />
  );
};
const DropCardPage = () => {
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) return null;

  return (
    <>
      <DropWarning />
      <Search slug={currentUser.slug} id={currentUser.id} />
    </>
  );
};

export default DropCardPage;
